import React from 'react';
import { Link } from 'react-router-dom';

import JobSidebarForm from 'components/job/jobSidebar/JobSidebarForm';
import { dynamicClassName } from 'utils/dynamicClassName';
import { handleTagEvent } from 'utils/tagManagerUtils';

const HREF = '/contact/nous-contacter?q=emploi_candidature_spontannee';

export default function JobSidebar() {
  const containerClass = dynamicClassName('col col-md-4 col-lg-3');
  const asideClass = dynamicClassName('sidebar');

  const onClick = e => {
    handleTagEvent('barre_navigation', 'clic_contacter_club', `/contact/nous-contacter?q=emploi_proposition`);
  };

  return (
    <div className={containerClass.build()}>
      <aside className={asideClass.build()}>
        <JobSidebarForm />

        <div className="box card card--find ">
          <div className="card__thumbnail img-blue-dark" style={{ backgroundImage: "url('/img/card/ball.jpg')" }}></div>
          <div className="card__body">
            <h3 className="card__title">Candidature spontanée</h3>
            <p className="ft-white-secondary mb-0">N’hésitez pas à nous adresser votre candidature spontanée.</p>
          </div>

          <div className="card__footer">
            <Link to={HREF} className="btn btn--white btn--full" onClick={onClick}>
              Contactez-nous
            </Link>
          </div>
        </div>
      </aside>
    </div>
  );
}
